import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'


const MemberDropout = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pb_50">
					<h3>탈퇴하기 전에 확인해주세요.</h3>
					<div className={`${styles["resign-guide"]} mt_40`}>
						<h4>개인정보 이용내역 안내</h4>
						<p className="mt_20">
							신용정보법 제18조의 6(본인신용정보관리회사의 행위규칙)에 따라 법령에 따른 통지의무사항으로 회원님의 개인정보 이용내역을 안내해드립니다. 자세한 내용은 데이터영수증으로 확인하시기 바랍니다.
						</p>
						<span className="mt_20">
							기간 : 2021-07-23 ~ 2021-07-31 기준<br />
							건수 : 6건(서비스동의 3건, 데이터수집 3건)
						</span>
					</div>
					<Button className="btn btn--big mt_30">데이터 영수증 확인하기</Button>
				</div>
			</div>
			<div className="padding">
				<div className={styles["resign-box"]}>
					서비스 탈퇴시 관련법령에 의거하여 보존하는 최소한의 정보 이외에 이용자를 식별할 수 있는 모든 개인정보는 지체없이 삭제되고 데이터연동도 모두 철회됩니다. 또한 해당 정보는 향후 서비스 재가입시 복구할 수 없습니다.
				</div>
				<div className="chk mt_20">
					<input type="checkbox" id="check1" name="" />
					<label htmlFor="check1">
						<span>안내사항을 모두 확인하였으며 동의합니다.</span>
					</label>
				</div>
				<Button className="btn btn--big btn--dark mt_40">탈퇴하기</Button>
			</div>
		</div>
	)
}

export default MemberDropout
